var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import { tokens } from '../tokens';
// Return size of the icon based on size of the text
// If the unit is other than px it defaults to medium size
function useIconSize(targetRef) {
    var _a = __read(useState('medium'), 2), size = _a[0], setSize = _a[1];
    useEffect(function () {
        var element = targetRef.current;
        if (element != null) {
            var fontSize = window.getComputedStyle(element).fontSize;
            if (fontSize.match(/[0-9]+px/) != null) {
                if (parseInt(fontSize, 10) < parseInt(tokens.fontSizes.medium, 10)) {
                    setSize('small');
                }
                else if (parseInt(fontSize, 10) > parseInt(tokens.fontSizes.xxlarge, 10)) {
                    setSize('large');
                }
            }
        }
    }, [targetRef]);
    return size;
}
export default useIconSize;
